export const EXCMRELATION_SHOW_RESET = 'EXCMRELATION_SHOW_RESET'
export const EXCMRELATION_SHOW_SET_ERROR = 'EXCMRELATION_SHOW_SET_ERROR'
export const EXCMRELATION_SHOW_SET_RETRIEVED = 'EXCMRELATION_SHOW_SET_RETRIEVED'
export const EXCMRELATION_SHOW_TOGGLE_LOADING = 'EXCMRELATION_SHOW_TOGGLE_LOADING'
